var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es388.js.map
